import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ActualizarEstadoSiiRequest } from "../models/Dte/ActualizarEstadoSiiRequest";
import { DetalleDte } from "../models/Dte/DetalleDte";
import { DteEmitidoFile } from "../models/Dte/DteEmitidoFile";
import { DteExportacionCompleto } from "../models/Dte/Exportacion/DteExportacionCompleto";
import { FacturaExportacionFilter } from "../models/Dte/Exportacion/FacturaExportacionFilter";
import { FacturaExportacion } from "../models/Dte/FacturaExportacion";
import { ReenvioEmailRequest } from "../models/Dte/ReenvioEmailRequest";
import { ReferenciaDte } from "../models/Dte/ReferenciaDte";
import { ReutilizacionMasivaRequest } from "../models/Dte/ReutilzacionMasivaRequest";
import { NotaCredito } from "../models/NotaCredito";
import { NotaDebito } from "../models/NotaDebito";
import { Receptor } from "../models/Receptor/Receptor";
import { Traza } from "../models/Traza";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Response } from "../shared/models/Response";

@Injectable({
	providedIn: "root",
})
export class DteExportacionService {
	private REST_API_SERVER = environment.backend_server + "/Exportacion";
	private REST_API_SERVER_DTE = environment.backend_server + "/dte";
	private REST_API_SERVER_ONVISION = environment.backend_server + "/Impresion";
	private REST_API_SERVER_DebitNote = environment.backend_server + "/NotaDebito";
	private auth = {};

	constructor(private http: HttpClient) {}

	public getDataByPage(filtro: FacturaExportacionFilter, page: Page): Observable<PagedResponse<FacturaExportacion>> {
		// let stringRut = "&rutReceptor=" + filtro.rutReceptor;
		// if (filtro.rutReceptor == "") {
		//   stringRut = "";
		// }
		let stringEstadoSii = filtro.estadoSii ? "&estadoSii=" + filtro.estadoSii : "";
		return this.http.get<PagedResponse<FacturaExportacion>>(
			this.REST_API_SERVER +
				"/list/filter?emisorId=" +
				filtro.emisorId +
				// "&importacionMasivaId=" +
				// filtro.importacionMasivaId +
				"&tipoDteId=" +
				filtro.tipoDteId +
				"&fechaDesde=" +
				(filtro.fechaDesde != undefined ? filtro.fechaDesde : "") +
				"&fechaHasta=" +
				(filtro.fechaHasta != undefined ? filtro.fechaHasta : "") +
				// stringRut +
				"&razonSocial=" +
				(filtro.razonSocial != undefined ? filtro.razonSocial : "") +
				"&PuertoId=" +
				filtro.puerto +
				"&Reutilizado=" +
				(filtro.reutilizado != undefined ? filtro.reutilizado : "") +
				"&TrackId=" +
				(filtro.trackId != undefined ? filtro.trackId : "") +
				"&CodigoPais=" +
				filtro.pais +
				"&ModalidadVentaId=" +
				filtro.modalidad +
				"&ClausulaVentaId=" +
				filtro.clausula +
				"&folio=" +
				(filtro.folio ? filtro.folio : "") +
				stringEstadoSii +
				"&SucursalId=" +
				(filtro.sucursalId != undefined ? filtro.sucursalId : "") +
				"&importacionMasivaId=" +
				filtro.importacionMasivaId +
				"&pageNumber=" +
				page.pageNumber +
				"&pageSize=" +
				page.pageSize
		);
	}

	getDetalleDteExportacion(dteId: string): Observable<Response<DetalleDte[]>> {
		return this.http.get<Response<DetalleDte[]>>(this.REST_API_SERVER + "/detalle?dteId=" + dteId);
	}

	getReceptorDte(dteId: string): Observable<Response<Receptor>> {
		return this.http.get<Response<Receptor>>(this.REST_API_SERVER + "/receptor?dteId=" + dteId);
	}

	public getXml(dteId: string): Observable<Response<DteEmitidoFile>> {
		return this.http.get<Response<DteEmitidoFile>>(this.REST_API_SERVER_DTE + "/xml?dteId=" + dteId);
	}

	public getPdf(dteId: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER_ONVISION + "/pdf/exporta?dteId=" + dteId);
	}

	public getTrace(dteId: string): Observable<Response<Traza[]>> {
		return this.http.get<Response<Traza[]>>(this.REST_API_SERVER_DTE + "/trazabilidad?dteId=" + dteId);
	}

	public getZip(request): Observable<Blob> {
		return this.http.post(this.REST_API_SERVER_DTE + "/download-zip",request, { responseType: 'blob' });
	}

	public getReferencias(dteId: string): Observable<Response<ReferenciaDte[]>> {
		return this.http.get<Response<ReferenciaDte[]>>(this.REST_API_SERVER + "/referencias?dteId=" + dteId);
	}
	public creditNoteDteExportNullification(note: NotaCredito): Observable<Response<FacturaExportacion>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER + "/nota_credito/anulacion", formData);
		}
	}
	public debitNoteDteExportNullification(note: NotaDebito): Observable<Response<FacturaExportacion>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER + "/nota_debito/anulacion", formData);
		}
	}
	public creditNoteNullification(note: NotaCredito): Observable<Response<FacturaExportacion>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER + "/nota_credito/anulacion", formData);
				break;

			case 1: //montos
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("detalleString", JSON.stringify(note.itemsNota));
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER + "/nota_credito/corrige_monto", formData);

			case 2: //textos
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("detalleString", JSON.stringify(note.itemsNota));
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentarioCorreccionTexto);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER + "/nota_credito/corrige_texto", formData);
		}
	}

	public debitNoteNullification(note: NotaDebito): Observable<Response<FacturaExportacion>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER_DebitNote + "/anulacion", formData);
		}
	}

	public debitNoteNullificationInterests(note: NotaDebito): Observable<Response<FacturaExportacion>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0: //Intereses
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);		
				if (note.exento > 0) {
					formData.append("exento", note.exento.toString());
					formData.append("iva", "0");
					formData.append("neto", "0");
				} else {
					formData.append("neto", note.neto.toString());
					formData.append("iva", note.iva.toString());
					formData.append("exento", "0");
				}
				formData.append("total", note.total.toString());
				return this.http.post<Response<FacturaExportacion>>(this.REST_API_SERVER_DebitNote + "/intereses", formData);
		}
	}

	getCompleteDetails(dteId): Observable<Response<DteExportacionCompleto>> {
		return this.http.get<Response<DteExportacionCompleto>>(this.REST_API_SERVER + "/dte/detalle?dteId=" + dteId);
	}

	resendDte(request: ActualizarEstadoSiiRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER_DTE + "/updateSiiStatus", request);
	}

	resendEmailSii(request: ReenvioEmailRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER_DTE + "/resendEmailSii", request);
	}
	reuse(dteId: string): Observable<Response<boolean>> {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER_DTE + "/reuseFolio/" + dteId);
	}
	massivereuse(request: ReutilizacionMasivaRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER_DTE + "/massiveReuseFolio", request);
	}
}
